export const durationMixin = {
	methods: {
		format_duration(minutes) {
			if (minutes == 0) {
				return '0h';
			}

			let hours = Math.floor(minutes / 60.0);
			let mins = minutes - (hours * 60.0);

			let fmt = '';
			if (hours > 0) {
				fmt += hours + 'h';
				if (mins > 0) {
					fmt += ' ';
				}
			}

			if (mins > 0) {
				fmt += mins + 'm';
			}

			return fmt;
		}
	}
}